export const SeverityLabelMap = {
    'severityFactor-00': 'Reduced',
    'severityFactor-10': 'Neutral',
    'severityFactor-20': 'Increased',
};
//# sourceMappingURL=consts.js.map